import { createAsyncThunk } from '@reduxjs/toolkit';
import profileModel from 'store/models/profile';
import {
  TRespondentProfileData,
  TRespondentUpdateRequest,
} from '../types/profileSchema';

//GET
export const fetchRespondentProfile = createAsyncThunk(
  'profile/fetchRespondentProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response: { data: { data: TRespondentProfileData } } =
        await profileModel.getRespondentProfile();

      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//PUT
export const fetchRespondentUpdatetProfile = createAsyncThunk(
  'profile/fetchRespondenUpdatetProfile',
  async (data: TRespondentUpdateRequest, { rejectWithValue }) => {
    try {
      const response: { data: { data: TRespondentProfileData } } =
        await profileModel.putRespondentProfile(data);

      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
